<template>
  <section class="tables new-updated-design">
    <vue-snotify></vue-snotify>
    <form
      class="forms-sample"
      @submit.stop.prevent="onSubmit"
      autocomplete="off"
    >
      <div class="row mt-5">
        <div class="col-md-12 d-flex align-items-stretch grid-margin">
          <div class="row flex-grow" style="width: 100%">
            <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-header">
                  <h4 v-if="!this.form.id" class="card-title">Add Survey</h4>
                  <h4 v-if="this.form.id" class="card-title">Update Survey</h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group label="Survey Name" label-for="FirstName">
                        <b-form-input
                          type="text"
                          id="surveyName"
                          name="surveyName"
                          placeholder="Survey Name"
                          v-model="$v.form.surveyName.$model"
                          :state="
                            $v.form.surveyName.$dirty
                              ? !$v.form.surveyName.$error
                              : null
                          "
                          aria-describedby="input-1-live-feedback"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >This is a required field.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="Email"
                          >To Show Radio Button Enter Options
                          <span class="text-danger"
                            >(e.g: Option1&amp;option2&amp;option3)</span
                          ></label
                        >
                        <label for="Email"
                          >For Member Typing Answers
                          <span class="text-danger"
                            >(Leave the options field blank)</span
                          ></label
                        >
                      </div>
                    </div>
                  </div>
                  <div style="overflow: auto">
                    <div
                      class="row"
                      v-for="(input, k) in form.inputs"
                      :key="`question-${k}`"
                      style="flex-wrap: nowrap; min-width: 500px"
                    >
                      <div class="col-md-4 col-sm-5">
                        <div class="form-group">
                          <div v-if="k > 0 && form.id">
                            <b-form-group label="Question" label-for="Question">
                              <b-form-input
                                type="text"
                                name="question[]"
                                placeholder="Question"
                                v-model="input.question"
                                aria-describedby="input-1-live-feedback"
                              >
                              </b-form-input>
                              <span :id="`error-${k}`" :class="toggelClass"
                                >This is a required field.</span
                              >
                            </b-form-group>
                          </div>
                          <div v-if="!form.id">
                            <b-form-group label="Question" label-for="Question">
                              <b-form-input
                                type="text"
                                name="question[]"
                                placeholder="Question"
                                v-model="input.question"
                                aria-describedby="input-1-live-feedback"
                              >
                              </b-form-input>
                              <span :id="`error-${k}`" :class="toggelClass"
                                >This is a required field.</span
                              >
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-5">
                        <div class="form-group">
                          <div v-if="k > 0 && form.id">
                            <b-form-group label="Options" label-for="Options">
                              <b-form-input
                                type="text"
                                name="options[]"
                                placeholder="Options"
                                v-model="input.options"
                                aria-describedby="input-1-live-feedback"
                              >
                              </b-form-input>
                              <b-form-invalid-feedback
                                id="input-1-live-feedback"
                                >This is a required field.
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </div>
                          <div v-if="!form.id">
                            <b-form-group label="Options" label-for="Options">
                              <b-form-input
                                type="text"
                                name="options[]"
                                placeholder="Options"
                                v-model="input.options"
                                aria-describedby="input-1-live-feedback"
                              >
                              </b-form-input>
                              <b-form-invalid-feedback
                                id="input-1-live-feedback"
                                >This is a required field.
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-2">
                        <div class="form-group">
                          <span v-if="k > 0 && form.id">
                            <i
                              style="margin: 23px"
                              class="fas fa fa-minus-circle"
                              @click="remove(k, input)"
                              v-show="k || (!k && form.inputs.length > 1)"
                            ></i>
                          </span>
                          <span v-if="!form.id">
                            <i
                              style="margin: 23px"
                              class="fas fa fa-minus-circle"
                              @click="remove(k, null)"
                              v-show="k || (!k && form.inputs.length > 1)"
                            ></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-">
                      <div
                        class="form-group"
                        v-for="(input, k) in form.inputs"
                        :key="k"
                      >
                        <span>
                          <i
                            class="fas fa fa-plus-circle"
                            @click="add(k)"
                            v-show="k == form.inputs.length - 1"
                          ></i>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6 mt-3">
                      <b-button  style="float: right" type="button" @click="goBack">Back</b-button>
                      <b-button
                        type="submit"
                        variant="success"
                        :disabled="isDisabled"
                        class="btn float-right btn-success"
                      >
                        <span v-if="!this.form.id">Submit</span>
                        <span v-if="this.form.id">Update</span>
                      </b-button>
                    </div>
                  </div>
                  <!--                                </form>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Vue from "vue";
import API from "@/api";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  email,
  requiredIf,
  sameAs,
  integer,
} from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "add_survey",
  mixins: [validationMixin],
  data() {
    return {
      form: {
        id: "",
        surveyName: "",
        inputs: [
          {
            id: 0,
            question: "",
            options: "",
          },
        ],
      },
      toggelClass: "error-message-hide",
      errorCount: "",
      isDisabled: false,
    };
  },
  validations: {
    form: {
      surveyName: {
        required,
      },
    },
  },
  mounted() {
    this.form.id = this.$route.params.id;
    if (this.form.id && this.form.id !== "undefined") {
      this.readonly = true;
    } else {
      this.readonly = false;
    }
    this.editMember();
  },
  methods: {
    goBack() {
      this.$router.go(-1); // Navigate back one step in the browser history
    },
    onSubmit() {
      this.errorCount = "";
      this.form.inputs.forEach((item, index) => {
        if (item.question == "") {
          if (this.form.id && index == 0) {
            this.errorCount = "";
          } else {
            this.errorCount = 1;
            document.getElementById("error-" + index).className =
              "error-message-show";
          }
        }
        if (item.options == "") {
          this.form.inputs[index].options = "empty";
        }
        if (item.question) {
          document.getElementById("error-" + index).className =
            "error-message-hide";
        }
      });
      if (this.errorCount) {
        return;
      }

      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      // this.isDisabled = true;
      API.addUpdateSurvey(
        this.form,
        (data) => {
          this.isDisabled = false;
          if (!this.form.id) {
            if (data.status === 410) {
              this.$showNotification(data, "error");
            } else {
              this.$showNotification(data, "success");
              this.$router.push({ name: "edit_survey" });
            }
          } else {
            if (data.status === 200) {
              this.$showNotification(data, "success");
              this.$router.push({ name: "edit_survey" });
            } else {
              this.$showNotification({ message: "Please try again." }, "error");
            }
          }
        },
        (err) => {
          this.isDisabled = false;
          console.log(err);
          this.$showNotification({ message: "Failed system error" }, "error");
        }
      );
    },

    formatDate(value, event) {
      if (value) {
        return moment(value).format("MMM dd, yyyy");
      }
    },
    editMember() {
      if (this.$route.params.survey) {
        this.survey = this.$route.params.survey;
        this.form.surveyName = this.survey.surveyName;
        this.form.id = this.survey.id;
        API.getQuestions(
          this.form.id,
          (data) => {
            data.data.forEach((q) => {
              this.add(q);
            });
          },
          (err) => {}
        );
      }
    },
    add(index) {
      if (index.question) {
        this.form.inputs.push({
          id: index.id,
          question: index.question,
          options: index.options,
        });
      } else {
        this.form.inputs.push({ id: 0, question: "", options: "" });
      }
    },
    remove(index, formdata) {
      if (formdata) {
        const shouldDelete = confirm(
          "Are you sure you want to delete this question?"
        );
        if (shouldDelete) {
          console.log(formdata);
          API.deleteQuestion(
            formdata.id,
            (data) => {
              if (data.status === 200) {
                this.$showNotification(data, "success");
              } else {
                this.$showNotification(
                  { message: "Please try again." },
                  "error"
                );
              }
            },
            (err) => {}
          );
          this.form.inputs.splice(index, 1);
        }
      } else {
        console.log(index);
        this.form.inputs.splice(index, 1);
      }
    },
  },
  computed: {},
};
</script>
